<template>
  <keep-alive include="activityList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Guess",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
